module.exports = __webpack_public_path__ + "static/media/collaborate.web.17cdea83.png";